export enum NotificationStatus {
    Seen = 1,
    Read = 2,
    Deleted = 3
}
